import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { BOOKS_PREVIEW_SEARCH } from "./data/book_preview_search";
import * as _ from "lodash";
import { useTranslations } from "../../hooks/use-translations";
import { Img } from "../shared/img";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel, Navigation, Autoplay } from "swiper";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useLanguage } from "../../hooks/use-language";

/**
 * Retorna el texto introductorio en libros y los filtros de busqueda
 * @param {object} texts contiene los textos de interfaz
 * @returns {JSX.Element} IntroHome
 */
export const FilterBooks = () => {

    const options = [...BOOKS_PREVIEW_SEARCH];
    const [currentOption, setCurrentOption] = useState();

    const lang = useLanguage();
    const textos = useTranslations({ section: "home", lang: lang });
    const booksPreviewTexts = textos?.filtro;


    const prevButtonBooksRef = useRef(null);
    const nextButtonBooksRef = useRef(null);

    const updateNavigation = (swiper) => {
        swiper.params.navigation.prevEl = prevButtonBooksRef?.current
        swiper.params.navigation.nextEl = nextButtonBooksRef?.current
        swiper.navigation.destroy()
        swiper.navigation.init()
        swiper.navigation.update()
    }

    const [isMobile, setIsMobile] = useState(window.innerWidth < 1200 ? true : false);

    //SET MOBILE
    useEffect(() => {
        const setMobile = () => {
            let validacion;
            if (window.innerWidth < 1200) {
                validacion = true;
            } else {
                validacion = false;
            }
            setIsMobile(validacion)
        }
        setMobile();
        window.addEventListener('resize', setMobile)
        return () => {
            window.removeEventListener('resize', setMobile)
        }
    }, [])


    return (
        <section className="container container-filter pt-2 d-flex align-items-center">
            <div className="d-flex w-100">
                <div className="col-lg-3 order-md-1 d-none d-lg-block">
                    <Img src="/img/matilda-libro.png" alt="blop sostiene una bandera" className="img-fluid" style={{ maxWidth: 250 }} />
                </div>
                <div className="col-lg-9 order-0">
                    <div className="tags-libros">
                        <div>
                            <h5
                                className="title5 onbackground-primary--color  pt-4 pb-3 text-center text-md-left"
                                style={{ fontWeight: 600 }}
                                dangerouslySetInnerHTML={{
                                    __html: `${textos?.sin_login?.coleccion ||
                                        "MakeMake ofrece a tu colegio y biblioteca  acceso a la mejor colección de libros de América Latina  para niños entre los 3 y 15 años"
                                        }`,
                                }}
                            ></h5>
                            <div className="wrapper-tags">
                                <section className="my-3 relative swiper-libros">
                                    <div className="wrapper-swiper-filtes-books">
                                        <Swiper
                                            className="swiper-filter-books libros-filter-books"
                                            slidesPerView={'auto'}
                                            spaceBetween={30}
                                            mousewheel={{
                                                forceToAxis: true,
                                            }}
                                            autoplay={{
                                                delay: 5000,
                                                disableOnInteraction: false,
                                            }}
                                            navigation={{
                                                nextEl: nextButtonBooksRef?.current,
                                                prevEl: prevButtonBooksRef?.current,
                                            }}
                                            onSwiper={(swiper) => {
                                                updateNavigation(swiper);
                                            }}
                                            modules={[Navigation, Mousewheel,  Autoplay]}
                                        >
                                            {options.map((option, i) => {
                                                return (
                                                    <SwiperSlide
                                                        key={`other${i}`}
                                                        className="focusable-by-children-secondary p-0"
                                                    >
                                                        <Link
                                                            to={option?.type === "gratis" ? `/coleccion/libros-gratuitos/` : `/busqueda?${option?.type}=${option?.value}`}
                                                            onClick={() => { setCurrentOption(option) }}
                                                            style={{ fontWeight: 500 }}
                                                            className={`p-2 px-3 preview-option-books focusable-red ${currentOption?.value === option?.value ? "selected" : ""
                                                                }`}

                                                        >
                                                            {_.get(booksPreviewTexts, option?.text?.translationPath) ||
                                                                option?.text?.default ||
                                                                "N/A"}
                                                        </Link>
                                                    </SwiperSlide>
                                                );
                                            })}
                                        </Swiper>
                                        <div className="button-swiper filter-books d-none d-md-block">
                                            <div className="buttons d-flex justify-content-center justify-content-md-between mt-3 mt-lg-0 px-0">
                                                <button ref={prevButtonBooksRef} aria-label="previous" className="home-swiper-navigation-buttons mr-3 mr-md-0">
                                                    <Icon className="icon" icon="material-symbols:arrow-back-rounded" width={20} />
                                                </button>
                                                <button ref={nextButtonBooksRef} aria-label="next" className="home-swiper-navigation-buttons">
                                                    <Icon className="icon" icon="material-symbols:arrow-forward-rounded" width={20} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>  
                    </div>

                </div>
            </div>

        </section >
    )
}